import { useContext } from "react";
import { AccountContext } from "../components/Account";

const useAuth = () => {

    return useContext(AccountContext);
}

export default useAuth;